import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { GetProjectsTasksDto } from '../../../../aumico-lib-cpmm-fe/src/lib/dtos/getProjectTasksDto.interface';
import { UpdateTaskDto } from '../../../../aumico-lib-cpmm-fe/src/lib/dtos/update-task-dto.interface';
import { CreateTaskRequestDto } from '../dtos/create-task-dto.interface';
import { GetTasksOfProjectDto } from '../dtos/getTasksOfProjectDto';
import { TaskMetaInformation } from '../interfaces/task-meta-information.interface';
import { TasksFilter } from '../interfaces/tasks-filter.interface';
import { SubjectType } from '../enums/subject-type.enum';

export const TasksOverviewActions = createActionGroup({
    source: 'Tasks Overview',
    events: {
        'Load Tasks Overview': props<{ filter?: TasksFilter }>(),
        'Tasks Overview Loaded': props<{ response: GetProjectsTasksDto }>(),
        'Tasks Overview Load Failure': props<{ error: HttpErrorResponse }>(),

        // REV-22155 — `subjectType` PERSON: a person project (`/person-projects/:id/tasks`)
        'Create Task': props<{ projectId: string; createTaskRequestDto: CreateTaskRequestDto; subjectType?: SubjectType }>(),
        'Task Created': props<{ response: TaskMetaInformation }>(),
        'Task Create Failure': props<{ error: HttpErrorResponse }>(),

        'Update Task': props<{ taskId: string; updateTaskDto: UpdateTaskDto }>(),
        'Task Updated': props<{ response: TaskMetaInformation }>(),
        'Task Update Failure': props<{ error: HttpErrorResponse }>(),

        'Bulk Update Tasks': props<{ taskIds: string[]; updateTaskDto: UpdateTaskDto }>(),
        'Bulk Tasks Updated': props<{ response: TaskMetaInformation[] }>(),
        'Bulk Update Tasks Failure': props<{ error: HttpErrorResponse }>(),

        'Update Task Status For Project By Task Id': props<{
            projectId: string;
            taskId: string;
            updateTaskDto: UpdateTaskDto;
        }>(),
        'Task Status For Project By Task Id Updated': props<{
            task: TaskMetaInformation;
            projectId: string;
            taskId: string;
        }>(),
        'Task Status For Project By Task Id Update Failure': props<{ error: HttpErrorResponse }>(),

        'Update All Tasks Status For Project By Section Id': props<{
            projectId: string;
            sectionId: string;
            updateTaskDto: UpdateTaskDto;
        }>(),
        'All Tasks Status For Project By Section Id Updated': props<{
            tasks: TaskMetaInformation[];
            projectId: string;
            sectionId: string;
        }>(),
        'All Tasks Status For Project By Section Id Update Failure': props<{ error: HttpErrorResponse }>(),

        'Delete Task': props<{ taskId: string }>(),
        'Task Deleted': props<{ taskId: string }>(),
        'Task Delete Failure': props<{ error: HttpErrorResponse }>(),

        'Bulk Delete Tasks': props<{ taskIds: string[] }>(),
        'Bulk Tasks Deleted': props<{ taskIds: string[] }>(),
        'Bulk Delete Tasks Failure': props<{ error: HttpErrorResponse }>(),

        'Load Project Tasks': props<{ projectId: string; filter?: TasksFilter; subjectType?: SubjectType }>(),
        'Project Tasks Loaded': props<{ response: GetTasksOfProjectDto }>(),
        'Project Tasks Load Failure': props<{ error: HttpErrorResponse }>(),
        'Clear Active Tasks': emptyProps(),
        'Reset Tasks Overview State': emptyProps(),
    },
});
